export const RESET_COURSES = 'RESET_COURSES';
export const FETCH_ONE = 'FETCH_ONE';
export const FETCH_NEXT = 'FETCH_NEXT';
export const FETCH_EARLIER_COURSES = 'FETCH_EARLIER_COURSES';
export const FETCH_LATER_COURSES = 'FETCH_LATER_COURSES';
export const CREATE_DRAFT_COURSE = 'CREATE_DRAFT_COURSE';

export const COURSE_DRAFT_INITIALIZE = 'COURSE_DRAFT_INITIALIZE';
export const COURSE_DRAFT_FILL = 'COURSE_DRAFT_FILL';



// WEBPACK FOOTER //
// ./src/store/course/types.js